import { styled } from '../../../config'

const Root = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  borderRadius: '8px',
  background: '$whiteA050',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '24px',
  transition: '100ms',
  '&:hover': {
    backgroundColor: '$whiteA150',
    cursor: 'pointer'
  },
  variants: {
    disabled: {
      true: {
        '&:hover': {
          backgroundColor: 'initial',
          cursor: 'not-allowed'
        }
      }
    },
    imageDisplay: {
      true: { padding: 0, border: 'none' }
    },
    unstyled: {
      true: {
        all: 'unset',
        '&:hover': {
          all: 'unset'
        }
      }
    }
  }
})

const FileListsRoot = styled('div', {
  variants: {
    hasFiles: {
      true: {
        marginTop: '24px'
      }
    }
  }
})

export const FilePickerPrimitive = {
  Root,
  FileListsRoot
}
